if (!window.Eurus.loadedScript.includes('cart-term.js')) {
  window.Eurus.loadedScript.push('cart-term.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCartTerm', (message) => ({
        message: message,
        checked: false,
        init() {
          this.checked = localStorage.cart_term_checked == 'agreed' ? true : false;

          this.$watch('checked', () => {
            this.save();
          });

          document.addEventListener('eurus:cart:validate', () => {
            this.checked = localStorage.cart_term_checked == 'agreed' ? true : false;
            if (!this.checked) Alpine.store('xCartHelper').validated = false;
          });
        },
        save() {
          clearTimeout(this.t);

          const func = () => {
            var status = this.checked ? 'agreed' : 'not agreed';
            Alpine.store('xCartHelper').updateCart({
              attributes: {
                'Terms and conditions': status
              }
            });
            localStorage.cart_term_checked = status;
          }
          
          this.t = setTimeout(() => {
            func();
          }, 200);
        }
      }));
    })
  });

  // Custom LiliTile Terms and Conditions functionality
  document.addEventListener('DOMContentLoaded', function() {
    
    // Create and inject the terms error popup HTML
    function createTermsErrorPopup() {
      if (document.getElementById('terms-error-popup')) {
        return; // Popup already exists
      }

      const popupHTML = `
        <div id="terms-error-popup" class="terms-popup-overlay" style="display: none;">
          <div class="terms-popup-container">
            <div class="terms-popup-content">
              <div class="terms-popup-header">
                <h3>Terms and Conditions Required</h3>
                <button class="terms-popup-close" onclick="hideTermsErrorPopup()">&times;</button>
              </div>
              <div class="terms-popup-body">
                <p>Please agree to the terms and conditions to proceed with checkout.</p>
              </div>
              <div class="terms-popup-footer">
                <button class="terms-popup-btn terms-popup-btn-primary" onclick="hideTermsErrorPopup()">
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      `;
      
      document.body.insertAdjacentHTML('beforeend', popupHTML);
    }

    // Show the terms error popup
    function showTermsErrorPopup() {
      createTermsErrorPopup();
      const popup = document.getElementById('terms-error-popup');
      if (popup) {
        popup.style.display = 'flex';
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
        
        // Focus trap
        const closeBtn = popup.querySelector('.terms-popup-close');
        if (closeBtn) closeBtn.focus();

        // Add event listeners for this popup instance
        addPopupEventListeners(popup);
      }
    }

    // Hide the terms error popup
    function hideTermsErrorPopup() {
      const popup = document.getElementById('terms-error-popup');
      if (popup) {
        popup.style.display = 'none';
        document.body.style.overflow = ''; // Restore scrolling
        
        // Remove event listeners
        removePopupEventListeners(popup);
      }
    }

    // Add event listeners for popup
    function addPopupEventListeners(popup) {
      // Close on ESC key
      const escHandler = function(e) {
        if (e.key === 'Escape') {
          hideTermsErrorPopup();
        }
      };
      
      // Close on click outside
      const clickHandler = function(e) {
        if (e.target === popup) {
          hideTermsErrorPopup();
        }
      };
      
      document.addEventListener('keydown', escHandler);
      popup.addEventListener('click', clickHandler);
      
      // Store handlers for removal later
      popup._escHandler = escHandler;
      popup._clickHandler = clickHandler;
    }

    // Remove event listeners for popup
    function removePopupEventListeners(popup) {
      if (popup._escHandler) {
        document.removeEventListener('keydown', popup._escHandler);
        popup._escHandler = null;
      }
      if (popup._clickHandler) {
        popup.removeEventListener('click', popup._clickHandler);
        popup._clickHandler = null;
      }
    }

    // Make functions global for onclick handlers
    window.showTermsErrorPopup = showTermsErrorPopup;
    window.hideTermsErrorPopup = hideTermsErrorPopup;

    // Handle "Read More" functionality for terms expansion
    function attachReadMoreListeners() {
      document.querySelectorAll('.more-terms-anchor').forEach(anchor => {
        // Remove existing listener if any
        anchor.removeEventListener('click', anchor._readMoreHandler);
        
        // Create new handler
        anchor._readMoreHandler = function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const parent = this.closest('.CartTermsHeaderLabel'); 
          const moreTerms = parent.querySelector('.more-terms');
          
          if (moreTerms) {
            const currentDisplay = window.getComputedStyle(moreTerms).display;
            
            if (moreTerms.style.display === 'inline' || currentDisplay !== 'none') {
              moreTerms.style.display = 'none';
              this.textContent = 'Read More';
            } else {
              moreTerms.style.display = 'inline';
              this.textContent = 'Read Less';
            }
          }
        };
        
        // Attach new listener
        anchor.addEventListener('click', anchor._readMoreHandler);
      });
    }

    // Attach initially
    attachReadMoreListeners();
    
    // Also attach when DOM content loads (double safety)
    document.addEventListener('DOMContentLoaded', attachReadMoreListeners);
    
    // Re-attach when cart updates (using MutationObserver)
    const readMoreObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          // Check if any added nodes contain terms
          for (let node of mutation.addedNodes) {
            if (node.nodeType === 1) { // Element node
              if (node.querySelector && node.querySelector('.more-terms-anchor')) {
                attachReadMoreListeners();
                break;
              }
            }
          }
        }
      });
    });
    
    readMoreObserver.observe(document.body, { 
      childList: true, 
      subtree: true 
    });

    // Handle checkout button click validation
    function handleCheckoutAttempt(event) {
      const cartTermsCheckboxes = document.querySelectorAll('input.cart__terms-checkbox');
      let isTermsChecked = false;

      // Check if any terms checkbox is checked
      cartTermsCheckboxes.forEach(checkbox => {
        if (checkbox.checked) {
          isTermsChecked = true;
        }
      });

      // If no terms checkboxes exist, allow checkout
      if (cartTermsCheckboxes.length === 0) {
        return true;
      }

      // If terms exist but none are checked, prevent checkout
      if (!isTermsChecked) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
        // Show error message
        document.querySelectorAll('.cart__terms-error').forEach(error => {
          error.style.display = 'block';
        });
        
        // Add error styling
        document.querySelectorAll('.cart__terms').forEach(terms => {
          terms.classList.add('notgtg');
        });

        // Show custom popup instead of alert
        showTermsErrorPopup();
        
        return false;
      }
      
      return true;
    }

    // Multiple event attachment strategies for maximum coverage
    
    // Strategy 1: Direct click event listener
    document.addEventListener('click', function(event) {
      // Check for checkout buttons
      if (event.target.matches('.cart__checkout, .cart__checkout *, button[name="checkout"], button[name="checkout"] *')) {
        const button = event.target.closest('.cart__checkout, button[name="checkout"]');
        if (button) {
          if (!handleCheckoutAttempt(event)) {
            return false;
          }
        }
      }
    }, true); // Use capture phase

    // Strategy 2: Form submit prevention
    document.addEventListener('submit', function(event) {
      // Check if this is a cart form
      if (event.target.matches('form[action*="cart"], form#cart, #cart')) {
        if (!handleCheckoutAttempt(event)) {
          return false;
        }
      }
    });

    // Strategy 3: Override button click handlers
    function attachCheckoutValidation() {
      const checkoutButtons = document.querySelectorAll('.cart__checkout, button[name="checkout"], #checkout-submit');
      checkoutButtons.forEach(button => {
        // Store original click handler
        const originalOnClick = button.onclick;
        
        button.onclick = function(event) {
          if (!handleCheckoutAttempt(event)) {
            return false;
          }
          // Call original handler if validation passes
          if (originalOnClick) {
            return originalOnClick.call(this, event);
          }
        };
      });
    }

    // Run attachment on load and when DOM changes
    attachCheckoutValidation();
    
    // Re-attach when new content is loaded (for cart updates)
    document.addEventListener('DOMContentLoaded', attachCheckoutValidation);
    
    // Watch for cart updates
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          attachCheckoutValidation();
        }
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Track checkbox states globally to avoid corruption from rapid events
    let checkboxStates = new Map();
    let processingEvents = new Set();

    // Initialize checkbox state tracking
    function initializeCheckboxStates() {
      const checkboxes = document.querySelectorAll('.cart__terms-checkbox');
      checkboxes.forEach(checkbox => {
        checkboxStates.set(checkbox.id, checkbox.checked);
      });
    }
    
    // Initialize on load
    initializeCheckboxStates();
    
    // Also initialize when Alpine.js is ready (for cart drawer)
    document.addEventListener('alpine:initialized', () => {
      initializeCheckboxStates();
    });
    
    // Re-initialize when new checkboxes are added
    const checkboxObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          // Check if any added nodes contain terms checkboxes
          for (let node of mutation.addedNodes) {
            if (node.nodeType === 1) { // Element node
              if (node.querySelector && node.querySelector('.cart__terms-checkbox')) {
                initializeCheckboxStates();
                break;
              }
            }
          }
        }
      });
    });
    checkboxObserver.observe(document.body, { childList: true, subtree: true });
    
    // Handle checkbox state changes with special Alpine.js drawer handling
    document.addEventListener('change', function(event) {
      if (event.target.matches('.cart__terms-checkbox')) {
        const checkboxId = event.target.id;
        const isNowChecked = event.target.checked;
        const wasChecked = checkboxStates.get(checkboxId) === true;
        const isDrawer = checkboxId === 'CartTermsHeaderDrawer';
        
        
        // Always update visuals immediately
        updateCheckboxVisuals(event.target);
        
        // Handle drawer vs cart differently due to Alpine.js re-rendering
        if (isDrawer) {
          // For drawer: Use more strict state management due to Alpine.js
          handleDrawerCheckboxChange(event.target, checkboxId, isNowChecked, wasChecked);
        } else {
          // For cart: Standard handling
          handleCartCheckboxChange(event.target, isNowChecked, wasChecked);
        }
        
        // Always update state after handling
        checkboxStates.set(checkboxId, isNowChecked);
      }
    });

    // Handle regular cart checkbox changes
    function handleCartCheckboxChange(checkbox, isNowChecked, wasChecked) {
      if (isNowChecked) {
        removeErrorStyling();
        enableCheckoutButtons();
      } else if (wasChecked) {
        showTermsErrorPopup();
        updateCheckboxVisuals(checkbox);
      }
    }

    // Handle drawer checkbox changes with Alpine.js protection
    function handleDrawerCheckboxChange(checkbox, checkboxId, isNowChecked, wasChecked) {
      // Skip if already processing to prevent Alpine.js re-render corruption
      if (processingEvents.has(checkboxId)) {
        return;
      }
      
      if (isNowChecked) {
        // Mark as processing to prevent Alpine.js from triggering false uncheck events
        processingEvents.add(checkboxId);
        removeErrorStyling();
        enableCheckoutButtons();
        
        // Reset processing flag after Alpine.js settles
        requestAnimationFrame(() => {
          processingEvents.delete(checkboxId);
        });
      } else if (wasChecked) {
        // Mark as processing immediately to prevent rapid events
        processingEvents.add(checkboxId);
        showTermsErrorPopup();
        updateCheckboxVisuals(checkbox);
        
        // Reset processing flag after Alpine.js settles
        requestAnimationFrame(() => {
          processingEvents.delete(checkboxId);
        });
      }
    }

    // Helper functions
    function removeErrorStyling() {
      document.querySelectorAll('.cart__terms').forEach(terms => {
        terms.classList.remove('notgtg');
      });
      document.querySelectorAll('.cart__terms-error').forEach(error => {
        error.style.display = 'none';
      });
    }

    function enableCheckoutButtons() {
      document.querySelectorAll('.cart__checkout').forEach(btn => {
        btn.classList.add('okay');
      });
    }

    // Handle clicks only on the checkbox area (first 30px of the label)
    document.addEventListener('click', function(event) {
      if (event.target.matches('.CartTermsHeaderLabel')) {
        const rect = event.target.getBoundingClientRect();
        const clickX = event.clientX - rect.left;
        
        // Only toggle if clicking within the checkbox area (first 30px)
        if (clickX <= 30) {
          const checkbox = event.target.querySelector('.cart__terms-checkbox');
          if (checkbox) {
            event.preventDefault();
            event.stopPropagation();
            
            // Update the global state before toggling
            checkboxStates.set(checkbox.id, checkbox.checked);
            checkbox.checked = !checkbox.checked;
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    });

    // Function to update checkbox visual state
    function updateCheckboxVisuals(checkbox) {
      const label = checkbox.closest('.CartTermsHeaderLabel');
      if (label) {
        if (checkbox.checked) {
          label.classList.add('checked');
        } else {
          label.classList.remove('checked');
        }
      }
    }

    // Override Alpine.js cart checkout if it exists
    function overrideAlpineCheckout() {
      if (typeof Alpine !== 'undefined' && Alpine.store && Alpine.store('xCartHelper')) {
        const store = Alpine.store('xCartHelper');
        
        // Override goToCheckout method
        if (store.goToCheckout && typeof store.goToCheckout === 'function') {
          const originalGoToCheckout = store.goToCheckout;
          store.goToCheckout = function(event) {
            // Create a fake event if none provided
            if (!event) {
              event = { preventDefault: () => {}, stopPropagation: () => {}, stopImmediatePropagation: () => {} };
            }
            
            if (handleCheckoutAttempt(event)) {
              return originalGoToCheckout.call(this, event);
            }
            return false;
          };
        }
        
        // Override other potential checkout methods
        if (store.checkout && typeof store.checkout === 'function') {
          const originalCheckout = store.checkout;
          store.checkout = function(event) {
            if (handleCheckoutAttempt(event || {})) {
              return originalCheckout.call(this, event);
            }
            return false;
          };
        }
      }
    }

    // Try to override immediately
    overrideAlpineCheckout();
    
    // Try again when Alpine is initialized
    if (typeof Alpine !== 'undefined') {
      document.addEventListener('alpine:init', overrideAlpineCheckout);
    }
    
    // Also try after a short delay to catch late Alpine initialization
    setTimeout(overrideAlpineCheckout, 1000);
    setTimeout(overrideAlpineCheckout, 3000);

  });
};